"use server";

import { gql } from "@apollo/client";

import apiGatewayClient from "@utils/apiClients";

const GENERATE_INTERCOM_TOKEN_MUTATION = gql`
  mutation GenerateIntercomToken {
    generateIntercomToken {
      token
      app_id
    }
  }
`;
export const generateIntercomToken = async (
  accessToken: string,
  accessRefreshToken: string
) => {
  const data = await apiGatewayClient(accessToken, accessRefreshToken).mutate({
    mutation: GENERATE_INTERCOM_TOKEN_MUTATION,
    context: {
      headers: { Authorization: `Bearer ${accessToken}` },
    },
  });

  return data.data.generateIntercomToken;
};
